export enum MenuIds {
	// New (in correct nav order)
	Home = 'apps-flexera-one-home',
	Favorites = 'apps-flexera-one-favorites'
}
